import { AuthConsumer } from '@friendemic/sso-consumer';

export const authConsumer = new AuthConsumer({
  clientId: `${process.env.REACT_APP_CLIENT_ID}`,
  providerHost: `${process.env.REACT_APP_SSO_HOST}`,
  withCredentials: process.env.REACT_APP_ENVIRONMENT !== 'development',
});
